import React from 'react';
import ReactDOM from 'react-dom';
import GoogleMapReact from 'google-map-react';
import Api from '../Shared/Api';
import { fitBounds } from 'google-map-react/utils';
import { SchedulerInstance } from '../Shared/AppointmentScheduler/AppointmentScheduler';
import URLSearchParams from 'url-search-params';
import Screen, { Default } from '../Shared/Helpers/Screen';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import './DealerLocator.scss';

function distance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1 / 180
    var radlat2 = Math.PI * lat2 / 180
    var theta = lon1 - lon2
    var radtheta = Math.PI * theta / 180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180 / Math.PI
    dist = dist * 60 * 1.1515
    if (unit == "K") { dist = dist * 1.609344 }
    if (unit == "N") { dist = dist * 0.8684 }
    return dist
}

function getRegionPhone(item) {
    if (item.externalPhoneNumber === 0) {
        return (
            <a className="phone hidden-xs" href={`tel:${item.phoneNumberString}`}>{item.phoneNumberString}</a>
        );
    }
    else {
        return (
            <a className="phone hidden-xs" href={`tel:${item.externalPhoneNumberString}`}>{item.externalPhoneNumberString}</a>
        );
    }
}

function getMulticenterPhone(item) {
    if (item.externalPhoneNumberMultiCenter === 0) {
        return (
            <a className="phone hidden-xs" href={`tel:${item.phoneNumberString}`}>{item.phoneNumberString}</a>
        );
    }
    else {
        return (
            <a className="phone hidden-xs" href={`tel:${item.externalPhoneNumberMultiCenterString}`}>{item.externalPhoneNumberMultiCenterString}</a>
        );
    }
}

function getDealerPhone(hasCampaign, isMulticenter, item) {
    if (hasCampaign) {
        return getRegionPhone(item);
    }
    else {
        if (isMulticenter) {
            return getMulticenterPhone(item);
        }
        else {
            return getRegionPhone(item);
        }
    }
}

const DealerContent = (props) => {
    var distanceInMiles = props.distanceInMiles;
    const scheduleTimes = props.isDetailed
        ? props.item.sheduleTimes.map(item => (<p>{item.stringFormat}</p>))
        : null
    //const scheduleTimesAlways = props.item.sheduleTimes.map(item => (<p>{item.stringFormat}</p>));
    
    return (<div className="location-item" >
        <div>
            <h3>{props.item.externalName}</h3>
            <address>{props.item.address}</address>
            {
                distanceInMiles > -1 &&
                (<p>
                    {distanceInMiles} miles away
                     </p>)
            }
            {scheduleTimes}

            {getDealerPhone(props.hasCampaign, props.isMulticenter, props.item)}

            <div className="details">
                {
                    props.item.websiteLink &&
                    (<a href={props.item.websiteLink} target="_blank">
                        {

                            <img src="/images/world.svg" alt="world"></img>
                        }
                        Visit Website
                        </a>)
                }

                <a href="javascript:void(0)" onClick={(e) => SchedulerInstance.show({ dealerId: props.item.id })} className="js-schedule-appointment">
                    {

                        <img src="/images/appointment-small.svg" alt="appointment-small"></img>
                    }
                    Schedule Appointment
                </a>

            </div>
        </div>

        <a className="phone-xs visible-xs" href={`tel:${props.item.phoneNumber}`}>Call</a>
    </div>)
}


class MapMarker extends React.Component {

    constructor(props) {
        super(props);

        this.onToogle = this.onToogle.bind(this);
        this.onHover = this.onHover.bind(this);
    }

    onToogle(e) {
        e.stopPropagation();

        let selectIndex = this.props.isSelected ? -1 : this.props.item.id;
        this.props.onSelect(selectIndex);
    }

    onHover(e) {
        e.stopPropagation();

        let hoveredIndex = this.props.isHovered || this.props.isSelected ? -1 : this.props.item.id;

        this.props.onHover(hoveredIndex);
    }

    render() {
        let hoveredClass = this.props.isHovered || this.props.isSelected ? 'hovered' : '';
        var distanceInMiles = -1;

        return (
            <div className={`map-marker ${hoveredClass}`}
                onMouseEnter={this.onHover}
                onMouseLeave={this.onHover}>
                <img onClick={(e) => this.onToogle(e)} className="marker" src="/images/shared/location-pin.svg" alt="location-pin"></img>
                {
                    this.props.isSelected &&
                    <div className="marker-hint">
                        <img onClick={this.onToogle} className="close-btn" src="/images/shared/header/xs-menu-close.svg" alt="xs-menu-close"></img>
                        <DealerContent item={this.props.item} isDetailed={true} distanceInMiles={this.props.item.distanceInMiles} isMulticenter={this.props.isMulticenter} hasCampaign={this.props.hasCampaign} />
                    </div>
                }
            </div>
        );
    }
}

class PointMarker extends React.Component {

    constructor(props) {
        super(props);

        this.onToogle = this.onToogle.bind(this);
        this.onHover = this.onHover.bind(this);
    }

    onToogle(e) {
        e.stopPropagation();

        let selectIndex = this.props.isSelected ? -1 : this.props.item.id;
        this.props.onSelect(selectIndex);
    }

    onHover(e) {
        e.stopPropagation();

        let hoveredIndex = -1

        this.props.onHover(hoveredIndex);
    }

    render() {
        let hoveredClass = this.props.isHovered || this.props.isSelected ? 'hovered' : '';

        return (
            <div className={`map-marker ${hoveredClass}`}
                onMouseEnter={this.onHover}
                onMouseLeave={this.onHover}>
                <img onClick={(e) => this.onToogle(e)} className="marker" src="/images/shared/location-map.svg" alt="location-map"></img>
                {
                    this.props.isSelected &&
                    <div className="marker-hint">
                        <img onClick={this.onToogle} className="close-btn" src="/images/shared/header/xs-menu-close.svg" alt="xs-menu-close"></img>
                    </div>
                }
            </div>
        );
    }
}

export default class DealerLocator extends React.Component {

    constructor(props) {
        super(props);

        var searchParams = new URLSearchParams(window.location.search);
        let dealer = searchParams.get('dealer')
            
        if (dealer == null) dealer = '';
        let dealerid = +searchParams.get('dealerid')
        if (dealerid == null) dealerid = '';

        this.state = {
            value: '',
            isDataLoaded: false,
            isMapLoaded: false,
            searchText: '',
            selectedItem: null,
            defaultMapCenter: { lat: 42.321267, lng: -100.605239 },
            defaultMapZoom: 7,
            mapCenter: null,
            mapZoom: null,
            mapSize: null,
            selectedIndex: dealerid ? dealerid : - 1,
            hoveredIndex: -1,
            initialData: [],
            data: [],
            address: dealer,
            searchPosition: { lat: 0, lng: 0 },
            hasCampaign: props.hasCampaign == "true",
            campaignID: props.campaignID,
            isMulticenter: props.isMulticenter == "true"
        };


        this.onFilter = this.onFilter.bind(this);
        this.resetName = this.resetName.bind(this);
        this.searchClicked = this.searchClicked.bind(this);
        this.refreshBounds = this.refreshBounds.bind(this);
        this.loadData = this.loadData.bind(this);
        this.onMapLoaded = this.onMapLoaded.bind(this);
        this.onMapChange = this.onMapChange.bind(this);
        //this.searchPosition = this.searchPosition.bind(this);
        this.onSelectItem = this.onSelectItem.bind(this);
        this.sortData = this.sortData.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.loadData();
      

    }

    onItemClick(id) {
        this.setState({ selectedIndex: id });

        if (id > 0) {
            // set center of selected dealer
            const item = this.state.data.find(x => x.id === id);
            const itemLocation = {
                lat: item.lat,
                lng: item.lng
            };
            this.setState({ mapCenter: itemLocation })

        }

    }

    onItemHover(id) {
        this.setState({ hoveredIndex: id });
    }

    sortData() {
        this.setState({
            data: this.state.data.sort(function (obj1, obj2) {
                return obj1.distanceInMiles - obj2.distanceInMiles;
            })
                .map((item) => {
                    var distanceInMiles = -1;
                    var orderIndex = 0;
                    if (this.state.searchPosition != null && this.state.searchPosition.lat != 0) {
                        distanceInMiles = distance(this.state.searchPosition.lat, this.state.searchPosition.lng, item.lat, item.lng);
                        distanceInMiles = Math.round(distanceInMiles * 10) / 10;//keep only 1 dec point
                        orderIndex = Math.round(distanceInMiles);
                    }
                    item.distanceInMiles = distanceInMiles;
                    return (
                        item
                    )
                })
        });
 
    }
    onSelectItem(address) {

        this.setState({ address: address });
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                this.setState({
                    searchPosition: {
                        lng: lng,
                        lat: lat
                    }

                }, () => {
                    this.sortData();
                    this.onItemClick(this.state.data[0].id);
                });

            });



      
    }

    onChange(e) {
        this.setState({ address: e });
        this.refreshBounds();
    }

    onFilter(e) {
        let text = e.target.address;
        this.setState({ searchText: address });
        this.filter(text);
    }

    resetName(e) {
        this.setState({ address: '' });
        this.filter('');
    }
    searchClicked(e) {
        let text = this.state.address;
        //this.setState({ searchText: address });
        this.onSelectItem(text);
    }

    filter(value) {

        let text = value.toLowerCase();

        let isLocked = (text === '' || text.length < 2);

        let result = isLocked
            ? this.state.initialData
            : this.state.initialData.filter((item) => {
                var searchText = text && text.trim();

                return item.externalName.toLowerCase().indexOf(searchText) > -1
                    ||
                    item.address.toLowerCase().indexOf(searchText) > -1;
            });

        this.setState({ data: result }, this.refreshBounds());
    }

    render() {
        const options = {
            types: ['(regions)'],
            componentRestrictions: { country: "us" }
        }

        const inputProps = {
            value: this.state.address,
            onChange: this.onChange,
            placeholder: 'Enter city, state or zip'
        };



        const listItems = this.state.data
            .sort((item1, item2) => {
                return item1.externalName.localeCompare(item2.externalName);
            })
            .map((item) => {
                let hoveredClass = item.id === this.state.hoveredIndex ? 'hovered' : '';
                let selectedClass = item.id === this.state.selectedIndex ? 'selected' : '';
                var distanceInMiles = -1;
                var orderIndex = 0;
                if (this.state.searchPosition != null && this.state.searchPosition.lat != 0) {
                    distanceInMiles = distance(this.state.searchPosition.lat, this.state.searchPosition.lng, item.lat, item.lng);
                    distanceInMiles = Math.round(distanceInMiles * 10) / 10;//keep only 1 dec point
                    orderIndex = Math.round(distanceInMiles);
                }
                var divStyle = {
                    order: orderIndex
                };
                item.distanceInMiles = distanceInMiles;
                return (
                    <li key={item.id}
                        onMouseEnter={(e) => this.onItemHover(item.id)}
                        onMouseLeave={(e) => this.onItemHover(-1)}
                        className={`${hoveredClass} ${selectedClass}`}
                        style={divStyle}
                        onClick={(e) => this.onItemClick(item.id)}>
                        <DealerContent item={item} distanceInMiles={item.distanceInMiles} isMulticenter={this.state.isMulticenter} hasCampaign={this.state.hasCampaign} />
                    </li>
                );
            }
            );



        const googlePoint = (
            <PointMarker key={999}
                id={999}
                lat={this.state.searchPosition.lat}
                lng={this.state.searchPosition.lng}
                onSelect={(id) => this.onItemClick(id)}
                onHover={(id) => this.onItemHover(id)}
                isHovered={false}
                isSelected={false} />
        );

        const markers = this.state.data.map((item) =>
            <MapMarker key={item.id}
                id={item.id}
                lat={item.lat}
                lng={item.lng}
                item={item}
                onSelect={(id) => this.onItemClick(id)}
                onHover={(id) => this.onItemHover(id)}
                isHovered={item.id === this.state.hoveredIndex}
                isSelected={item.id === this.state.selectedIndex}
                isMulticenter={this.state.isMulticenter} />
        );
        markers.push(googlePoint);

        return (
            <div className="dealer-locator-wrapper">
                <div id="locations-multicenter" className={this.state.isMulticenter ? "locations-multicenter" : "locations" }>
                    {this.state.isMulticenter == false &&
                    <div className="input-group">
                        <PlacesAutocomplete
                            options={options}
                            inputProps={inputProps}
                            googleLogo={false}
                            getItemValue={(item) => item.fullAddress}
                            renderItem={(item, isHighlighted) =>
                                <div key={item.id} className="menu-item" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                                    <img src="./images/location-small.svg" alt="location-small" />
                                    {item.fullAddress}
                                </div>
                            }
                            shouldItemRender={(item, value) => (item.fullAddress ? item.fullAddress.toLowerCase().indexOf(value.toLowerCase()) : -1) > -1}
                            menuStyle={{
                                borderRadius: '0',
                                position: 'fixed',
                                maxHeight: '250px',
                                maxWidth: '200px',
                                overflow: 'auto',
                                position: 'absolute',
                                top: 'initial',
                                left: 'initial'
                            }}
                            value={this.state.value}
                            //onEnterKeyDown={this.handleEnter}
                            onSelect={this.onSelectItem}
                        />
                        {
                            this.state.address.length > 0 &&
                            <span id="clearText" onClick={this.resetName} className="input-group-addon"><img src="/images/toggle-x.png" alt="toggle-x"></img></span>
                        }
                        <span id="searchIcon" onClick={this.searchClicked} className="input-group-addon"><img src="/images/search.svg" alt="search"></img></span>
                     </div>
                    }

                    {this.state.isMulticenter &&
                        <div>
                            <h3 className="text-location">LOCATIONS</h3>
                        </div>
                    }
                    <ul>{listItems}</ul>
                    <div className="disclaimer">For Locations outside of this market, visit <a href="http://www.aamco.com" target="_blank">AAMCO.com</a></div>
                </div>
                {
                    this.state.isMulticenter &&
                    <Default>
                        <div className="map">
                            <GoogleMapReact
                                zoom={this.state.mapZoom}
                                center={this.state.mapCenter}
                                onGoogleApiLoaded={this.onMapLoaded}
                                defaultCenter={this.state.defaultMapCenter}
                                defaultZoom={this.state.defaultMapZoom}
                                onChange={this.onMapChange}
                                style={{ width: '100%', height: '100%', position: 'relative' }}
                            >
            
                                {markers}
                            </GoogleMapReact>
                        </div>
                    </Default>
                }
                {
                    this.state.isMulticenter == false &&
                    <Default>
                        <div className="map">
                            <GoogleMapReact
                                zoom={this.state.mapZoom}
                                center={this.state.mapCenter}
                                onGoogleApiLoaded={this.onMapLoaded}
                                defaultCenter={this.state.defaultMapCenter}
                                defaultZoom={this.state.defaultMapZoom}
                                onChange={this.onMapChange}
                                style={{ width: '100%', height: '100%', position: 'relative' }}
                            >

                                {markers}
                            </GoogleMapReact>
                        </div>
                    </Default>
                }

            </div>
        );
    }

    onMapChange(e) {
        if (this.state.selectedIndex < 0 || !this.state.mapSize)
            this.setState({ mapSize: e.size }, this.refreshBounds);
    }

    onMapLoaded() {
        this.setState({ isMapLoaded: true }, this.refreshBounds);
    }

    loadData() {
        Api.getDealers(this.state.hasCampaign, this.state.campaignID).then(data => {
            this.setState({
                data: data.sort(function (obj1, obj2) {
                    return obj1.distanceInMiles - obj2.distanceInMiles;
                })
                    .map((item) => {
                        var distanceInMiles = -1;
                        var orderIndex = 0;
                        if (this.state.searchPosition != null && this.state.searchPosition.lat != 0) {
                            distanceInMiles = distance(this.state.searchPosition.lat, this.state.searchPosition.lng, item.lat, item.lng);
                            distanceInMiles = Math.round(distanceInMiles * 10) / 10;//keep only 1 dec point
                            orderIndex = Math.round(distanceInMiles);
                        }
                        item.distanceInMiles = distanceInMiles;
                        return (
                            item
                        )
                    }),
                initialData: data,
                isDataLoaded: true

            }, () => {
                if (this.state.selectedIndex > 0) {
                    this.onItemClick(this.state.selectedIndex);
                    this.refreshBounds();
                }
                else {
                    this.onSelectItem(this.state.address)
                    //this.onItemClick(this.state.data[0].id);
                    this.refreshBounds();
                }
            });

        });
    }

    refreshBounds() {
        if (this.state.isDataLoaded && this.state.isMapLoaded) {
            const maxZoom = 45;
            let bounds = this.getMapBounds(this.state.data);

            this.setState({
                mapCenter: bounds.center,
                mapZoom: bounds.zoom <= maxZoom ? bounds.zoom : maxZoom
            });
        }
    }

    getMapBounds(points) {

        let latitudes = points.map(x => x.lat).filter(x => x != 0);
        let longitudes = points.map(x => x.lng).filter(x => x != 0);



        let bounds = {
            se: {
                lat: Math.min(...latitudes),
                lng: Math.max(...longitudes)
            },
            nw: {
                lat: Math.max(...latitudes),
                lng: Math.min(...longitudes)
            }
        }

        if (points.length === 1) {
            bounds.nw.lat += 0.00001;
            bounds.nw.lng -= 0.00001;
        }

        let result = fitBounds(bounds, this.state.mapSize);

        return result;
    }
}

if (document.getElementById('dealerLocator') != null) {
    ReactDOM.render(<DealerLocator hasCampaign={document.getElementById('dealerLocator').getAttribute("hasCampaign")} isMulticenter={document.getElementById('dealerLocator').getAttribute("isMulticenter")} campaignID={document.getElementById('dealerLocator').getAttribute("campaignID")} />, document.getElementById('dealerLocator'));
}


// WEBPACK FOOTER //
// ./Src/DealerLocator/DealerLocator.jsx